export function asArray(item) {
    if (Array.isArray(item)) {
        return item;
    }
    return [item];
}
export function asArrayFirst(item) {
    return Array.isArray(item) ? item[0] : item;
}
export default asArray;
